import {useSelector} from "react-redux";

const useGetResource = (resource,selector) => {
    return useSelector(state => selector(state.admin.resources[resource].data));
};

export default useGetResource;